export default {
  'fee.section.basic': '基本信息',
  'fee.section.reportingRules': '报表规则',
  'fee.section.autoApplyRules': '自动添加规则',
  'fee.name': '费用名',
  'fee.foreign_name': '费用中文名',
  'fee.amount': '数值',
  'fee.associatedRoles': '关联的角色',
  'fee.taxable': '是否征税',
  'fee.is_taxable': '征税',
  'fee.is_non_taxable': '不征税',
  'fee.type': '类型',
  'fee.taxable.tooltip': '结账时会征收这个费用的税',
  'fee.delivery': '递送费',
  'fee.delivery.tooltip': '在创建电话递送订单时可以快速添加这个费用',
  'fee.gratuity': '小费',
  'fee.gratuity.tooltip': '在计算销售报表时把这个费用计算为‘小费’',
  'fee.autoApplyRule.limit': '当此费用作为‘递送费’时不能设置自动添加规则',
  'fee.name.required': '费用名必填',
  'fee.foreign_name.required': '费用中文名必填',
  'fee.amount.required': '数值必填',
  'fee.transactionAmountThreshold.required': '交易额必填',
  'fee.guestAmountThreshold.required': '客人数量必填',
  'fee.column.delivery': '递送费',
  'fee.column.delivery.tooltip': '在创建电话递送订单时可以快速添加这个费用',
  'fee.column.gratuity': '小费',
  'fee.column.gratuity.tooltip': '在计算销售报表时把这个费用计算为‘小费’',
  'fee.column.autoApply': '自动添加费用',
  'fee.new': '新建费用',
  'fee.edit': '编辑费用',
  'fee.action.edit': '编辑',
  'fee.action.delete': '删除',
  'fee.deletionPrompt': '确认要删除此费用吗？',
  'fee.trigger.all': '所有情况下',
  'fee.trigger.payByCard': '刷卡支付时',
  'fee.trigger.cardTransactionAmountLessThan': '如果刷卡支付金额少于',
  'fee.trigger.guestAmountEqOrGt': '如果客人数量大于或等于',
  'fee.action.addRule': '新建规则',
  'fee.orderSource.placeholder': '订单来源',
  'fee.serviceType.placeholder': '服务类型',
  'fee.reportingRules.title': '设置这个费用在订单和报表如何计算',
  'fee.includeInTipsCalculation': '计入到小费计算',
  'fee.includeInTipsCalculation.tooltip': '该费用会计入到小费的计算中。',
};
